import { render } from "./GhlSubaccount.vue?vue&type=template&id=40f4800c&ts=true"
import script from "./GhlSubaccount.vue?vue&type=script&lang=ts"
export * from "./GhlSubaccount.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__